<template>
  <b-dropdown :text="selectedText" class="custom-dropdown">
    <b-dropdown-item
      v-for="(option, index) in options"
      :key="'option_' + index + option.value"
      dropdown
      @click="selectOption(option)"
    >
      {{ option.text }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script lang="ts">
import type { SelectOptions } from '@/types/Components/SelectOptions'
import { defineComponent, computed, type PropType } from 'vue'

export default defineComponent({
  name: 'SimpleDropdown',
  props: {
    options: {
      type: Array as PropType<SelectOptions[]>,
      required: true,
    },
    modelValue: {
      type: String,
      default: null,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const selectedText = computed(() => {
      return (
        props.options.find((opt) => opt.value === props.modelValue)?.text || props.options[0]?.text || 'Select option'
      )
    })

    const selectOption = (option: SelectOptions) => {
      emit('update:modelValue', option.value)
    }

    return {
      selectedText,
      selectOption,
    }
  },
})
</script>

<style lang="scss" scoped>
.custom-dropdown {
  &.show {
    :deep(.dropdown-toggle) {
      background-color: #ffffff;
    }
  }

  &.border-0 {
    :deep(.dropdown-toggle) {
      border: none !important;
    }
  }

  :deep(.dropdown-menu) {
    transform: translate3d(0, 45px, 0) !important;
    z-index: 3;
    max-height: 400px;
    overflow-y: auto;
  }

  :deep(.dropdown-toggle) {
    width: 210px;
    height: 40px;
    font-size: 14px;
    color: #757575;
    border-color: #c8c8c8;
    padding-left: 15px;
    text-align: left;
    line-height: 0;
    text-overflow: ellipsis;
    overflow: hidden;
    background: #ffffff url(@/assets/img/icon-select.svg) right 14px top 14px / 12px 12px no-repeat !important;
    &:hover,
    &:focus,
    &:active {
      background-color: unset;
      border-color: #c8c8c8;
      color: #757575;
    }
    &::after {
      display: none;
    }
  }
}
</style>
